import { useQuery } from '@tanstack/react-query';
import { goalsDataGraphql } from './query';

export const QUERY_KEYS = {
  goalsData: 'goalsData',
};

export const useGoalsDataGql = (
  goalScope = 'ORG',
  author?: string,
  teamId?: string
) => {
  return useQuery(
    [QUERY_KEYS.goalsData, goalScope, author, teamId],
    () => goalsDataGraphql(goalScope, author, teamId),
    {
      select: (data) => data.GoalTable,
    }
  );
};
